var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m10.53 7.22 5.472 5.473-1.06 1.06L10 8.811l-4.942 4.942-1.06-1.06L9.468 7.22a.75.75 0 0 1 1.061 0","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }